"use client";
import { ChevronLeft as ArrowLeftIcon } from "lucide-react";
import useTranslate from "@app/_hooks/useTranslate";
import { Button, Dialog } from "@components/ui";
import { useHeaderContext } from "@context/headerContext";
import { MobileMenuContext } from "@context/mobileMenuContext";
import { useContext } from "react";

export default function MobileMenuHeader() {
  const t = useTranslate();
  useHeaderContext();
  const { navigationTree, setNavigationTree, setNavigationDirection } =
    useContext(MobileMenuContext);

  const isSubMenuActive = navigationTree.length > 1;

  if (isSubMenuActive) {
    return (
      <Dialog.Title>
        <Button
          className="flex items-center"
          onClick={() => {
            setNavigationDirection("left");
            setNavigationTree((prev) => {
              if (prev.length === 1) return prev;

              return prev.slice(0, prev.length - 1);
            });
          }}
        >
          <ArrowLeftIcon strokeWidth={1} className="mr-1 size-4.5" />
          {t("back")}
        </Button>
      </Dialog.Title>
    );
  }

  return <Dialog.Title>{t("menu")}</Dialog.Title>;
}
